var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-header",style:({
  'padding-top': ((-_vm.showHeader & 46) + "px")
})},[(_vm.showHeader)?_c('section',{staticClass:"layout-header-info"},[_c('h1',{staticClass:"system-name"},[_vm._v(_vm._s(_vm.SYSTEM_NAME.cnName))]),_vm._v(" "),_c('layout-user')],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"layout-header-nav-wrapper"},[_c('layout-main-nav',{attrs:{"line-height":_vm.navLineHeight}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e09713d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Header.vue
// module id = null
// module chunks = 